import {
    GET_COURSE_UNITS_FAIL,
    GET_COURSE_UNITS_SUCCESS,
    ADD_COURSE_UNIT_SUCCESS,
    ADD_COURSE_UNIT_FAIL,
    UPDATE_COURSE_UNIT_SUCCESS,
    UPDATE_COURSE_UNIT_FAIL,
    DELETE_COURSE_UNIT_SUCCESS,
    DELETE_COURSE_UNIT_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    courseUnits: [],
    error: null,
    loading: true,
    lastActionSuccess: false
};

const courseUnitReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des courseUnits
        case GET_COURSE_UNITS_SUCCESS:
            return {
                ...state,
                courseUnits: action.payload.courseUnits, // tableau d'objets course
                loading: false,
                error: null
            };

        case GET_COURSE_UNITS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une coursee
        case ADD_COURSE_UNIT_SUCCESS:
            return {
                ...state,
                courseUnits: [action.payload, ...state.courseUnits], // ajoute au début du tableau
                error: null,
                lastActionSuccess: true
            };

        case ADD_COURSE_UNIT_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Mise à jour d'une coursee
        case UPDATE_COURSE_UNIT_SUCCESS:
            return {
                ...state,
                courseUnits: state.courseUnits.map(courseUnit =>
                    courseUnit.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet course
                        : courseUnit
                ),
                error: null,
                lastActionSuccess: true
            };

        case UPDATE_COURSE_UNIT_FAIL:
            return {
                ...state,
                error: action.payload,
                lastActionSuccess: false
            };

        // Suppression d'une coursee
        case DELETE_COURSE_UNIT_SUCCESS:
            return {
                ...state,
                courseUnits: state.courseUnits.filter(
                    courseUnit => courseUnit.id !== action.payload
                ),
                error: null
            };


        case DELETE_COURSE_UNIT_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                lastActionSuccess: false 
            };


        default:
            return state;
    }
};

export default courseUnitReducer;
